/**
 * Header
 */

export default function Header() {
    const selectors = {
        'headerMenuWrapper' : '#header',
        'menuWrapper' : '#menu-header-menu',
        'mobileToggle' : '.js-mobile-menu-toggle',
        'headerMenuBottomToggle' : '.js-header-bottom-menu-toggle',
        'mobileBreakpoint' : 1024,
    };

    this.init = () => {
        this.handleMobileMenu();
        this.scroll();
    };

    this.handleMobileMenu = () => {
        jQuery(selectors.headerMenuWrapper)
            .on('click', '#menu-main-menu > .menu-item-has-children > a', function(e){
            if(jQuery(window).width() > selectors.mobileBreakpoint){
                return;
            }
            e.preventDefault();
            let $this = jQuery(this);
            let $parent = $this.parent();

            if(!$parent.hasClass('menu-shown')){
                $parent.addClass('menu-shown').find(">.sub-menu").slideDown(400);
                $parent.siblings().removeClass("menu-shown").find(">.sub-menu").slideUp(400, "swing");
            }else{
                $parent.removeClass("menu-shown").find(">.sub-menu").slideUp(400, "swing");
            }
        });

        jQuery(selectors.headerMenuWrapper)
            .on('click', '#menu-main-menu > .menu-item-has-children > .sub-menu .menu-item-has-children > a', function(e){
                e.preventDefault();
                let $this = jQuery(this);
                let $parent = $this.parent();

                if(!$parent.hasClass('menu-shown')){
                    $parent.addClass('menu-shown').find(">.sub-menu").slideDown(400);
                    $parent.siblings().removeClass("menu-shown").find(">.sub-menu").slideUp(400, "swing");
                }else{
                    $parent.removeClass("menu-shown").find(">.sub-menu").slideUp(400, "swing");
                }
            });

        jQuery(selectors.headerMenuWrapper).on('click', '.header-menu-overlay', function(e){
            e.preventDefault();
            jQuery("#mobile-menu-toggle").prop("checked", false).trigger("change");
            jQuery("body").css("overflow", "").removeClass("is-down").addClass("is-up")
        })
        jQuery("#mobile-menu-toggle").on("change", function(e){
            e.preventDefault();
            if(jQuery(this).is(":checked")){
                jQuery("body").css("overflow", "hidden").addClass("mobile-menu-shown")
            }else{
                jQuery("body").css("overflow", "").removeClass("mobile-menu-shown")
            }
        })
    }

    this.scroll = () => {
        var position = jQuery(window).scrollTop();

        jQuery(window).scroll(function() {
            var scroll = jQuery(window).scrollTop();
            if (scroll <= 0 || scroll <= position) {
                jQuery("body").addClass("is-up").removeClass("is-down")
            } else {
                jQuery("body").addClass("is-down").removeClass("is-up")
            }
            position = scroll;
        });
    }
}
